// Copies to the clipboard when the browser has no Web Share API. Returns true when it shared.
async function shareOrCopy(shareData, textToCopy) {
  try {
    if (!navigator.share) throw new Error("can't use navigator.share API");
    if (navigator.canShare && !navigator.canShare(shareData)) {
      throw new Error("can't share this data");
    }

    await navigator.share(shareData);

    return true;
  } catch (err) {
    navigator.clipboard.writeText(textToCopy);

    return false;
  }
}

export default shareOrCopy;
